/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getConvo.defs.js'
export { main as default } from './getConvo.defs.js'
